declare global {
  interface Window {
    dataLayer: any;
  }
}

interface PushEventProps {
  name: string;
  category: string;
  action: string;
  label?: string;
  value?: string | number;
  data?: Record<string, any>;
}

// Wrapper around pushing events to the data layer that Google Tag Manager uses that
// provides sane defaults for the information we care about in GTM
const pushEvent = ({ name, category, action, label = window.location.href, value = 0, data = {} }: PushEventProps) => {
  const timestamp = new Date();

  const event = {
    event: name,
    eventProps: {
      category,
      action,
      label,
      value,
      timestamp: timestamp.toISOString(),
      ...data,
    },
  };

  if (process.env.NODE_ENV === 'development') console.log(event);

  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push(event);
  }
};

export default {
  pushEvent,
};
